import debounce              from 'lodash/debounce'
import ApplicationController from '../../support/application_controller'
import WizardMixin           from '../../support/wizard_mixin'
import mixin                 from '../../support/mixin'

export default class extends mixin(ApplicationController, WizardMixin) {

  static targets = [
    ...super.targets,
    'smokingHabits',
    'smokingStoppedMonth',
    'smokingStoppedMonthInput',
    'smokingStoppedYear'
  ]

  static values = {
    ...super.values,
    stoppedMonthRequired: Boolean
  }

  static classes = [
    'hide'
  ]

  initialize() {
    this.toggleSmokingStoppedMonthDebounced = debounce(this.toggleSmokingStoppedMonth.bind(this), 500)
  }

  connect() {
    super.connect()
    this.toggleSmokingStoppedMonth()
  }

  // ==== Actions

  toggleSmokingStoppedMonth() {
    this.toggleTarget(this.smokingStoppedMonthTarget, this.stoppedMonthRequiredValue || this.smokingStoppedMonthVisible)
    this.changeSmokingHabits()
  }

  changeSmokingHabits() {
    this.dispatch('change', {
      bubbles: true,
      prefix:  'smoking-habits',
      detail:  {
        smokingHabits:       this.smokingHabits,
        smokingStoppedYear:  this.smokingStoppedYear,
        smokingStoppedMonth: this.smokingStoppedMonth
      }
    })
  }

  // ==== Getters

  get smokingStoppedMonthVisible() {
    return this.smokingStoppedYear === this.currentYear ||
      this.smokingStoppedYear === this.currentYear - 1
  }

  get smokingHabits() {
    return this.smokingHabitsTargets
      .find((input) => input.checked)
      ?.value
  }

  get smokingStoppedYear() {
    if (!this.smokingStoppedYearTarget.value) return undefined

    return parseInt(this.smokingStoppedYearTarget.value, 10)
  }

  get smokingStoppedMonth() {
    if (!this.smokingStoppedMonthInputTarget.value) return undefined

    return parseInt(this.smokingStoppedMonthInputTarget.value, 10)
  }

  get currentYear() {
    return new Date().getFullYear()
  }

}
